export const dashboard = {
    selectedMeter: '选择监控器:',
    analyticsLabel: '负荷识别与分析',
    period: '周期:',
    refreshPeriod: '刷新:',
    every1secs: '每 1 秒',
    every2secs: '每 2 秒',
    every5secs: '每 5 秒',
    every10secs: '每 10 秒',
    every30secs: '每 30 秒',
    every60secs: '每 60 秒',
    liveLoading: '实时数据监控',
    zoomIn: '放大',
    zoomOut: '缩小',
    pvEfficiency: '光伏效率',
    pvOwnUsage: '光伏自给能量消耗',
    pvProduced: '发电/使用',
    pvSold: '发电/已售',
    pvUsed: '消耗',
    pvBought: '已买',
    cloudSubscription: '订阅',
    until: '直到',
    switchData: '切换',
    noData: '无数据',
    wrongTime: '计算机时间不准确',
    secondGraph: '第二图表',
    premiumData: '高级数据',
    premiumVoltage: '电压',
    premiumApparentPower: '视在功率',
    premiumCurrent: '电流',
    premiumCosPhi: '功率因数',
    downloadSvg: '下载CSV文件',
    downloadExcel: '下载Excel文件',
    onePerSecond: '1秒钟1个样本',
    onePerMinute: '1分钟1个样本',
    onePer15Minutes: '15分钟1个样本',
    onePerHour: '1小时1个样本',
    resolution: '分辨率',
    kwhCost: '每千瓦时价格',
    wattUnit: '瓦',
    kwUnit: '千瓦',
    mwUnit: '兆瓦',
    kwhUnit: '千瓦时',
    kgUnit: '公斤',
    costUnit: '元',
    batteryCharge: '電池充電狀態',
    autonomy: '自治',
    grid: '網絡',
    production: '生產',
    battery: '電池',
    usage: '消耗',
    otherDevices: '其他設備',
    chartModeDevice: '設備',
    chartModePhases: '默認',
    E3DC: 'E3DC',
    EnphaseIqEnvoy: 'Enphase IQ Envoy',
    Fenecon: 'FENECON',
    froniusSolarapiV1: 'Fronius Solar Api V1',
    froniusGen24Modbus: 'Fronius Gen24 Modbus TCP/IP',
    kostalPiko: 'Kostal Piko',
    kostalPlenticore: 'Kostal Plenticore',
    kostalSem: 'Kostal Sem',
    kostalSemInverter: 'Kostal Sem Inverter',
    SIEMENS_SENTRON_PAC_FAMILY: 'Siemens Sentron PAC',
    SENEChome: 'SENEC.Home',
    HuaweiDongleSensor: 'Huawai Sun 2000 dongle & sensor',
    HuaweiSun2000dongle: 'Huawai Sun 2000 dongle',
    MTecEbGen2TCP: 'M-TEC Energy Butler GEN2',
    MTecEbGen3TCP: 'M-TEC Energy Butler GEN3',
    Phoenix: 'Phoenix',
    RctPower: 'RCT Power',
    Shelly1PmPv: 'Shelly 1PM PV',
    SmaDataManager: 'SMA Data Manager',
    SmaEnergyMeter: 'SMA Energy Meter',
    SmaHomeManager: 'SMA Home Manager',
    SmaHybrid: 'SMA Hybrid',
    SmaInverter: 'SMA Inverter',
    Solarwatt: 'Solarwatt',
    SolarEdgeHybrid: 'Solar Edge Hybrid',
    SolarEdgeInverter: 'Solar Edge Inverter',
    Solax: 'Solax',
    SolaxCloudApi: 'Solax Cloud',
    Sonnenbatterie: 'sonnenBatterie',
    Sungrow: 'Sungrow',
    SungrowHybrid: 'Sungrow Hybrid',
    Victron: 'Victron Energy',
    xelectrix: 'xelectrix',
    excelFromP1: '第一期開始：',
    excelFromP2: '第二期開始：',
    excelToP1: '第一期結束：',
    excelToP2: '第二期結束：',
    uploadLoadprofile: '上传负载配置文件',
    uploading: '上传中',
    uploadStarted: '文件上传开始成功，持续时间约5分钟',
    uploadFailed: '文件上传失败',
    noDataEnergyFlow: '此時此瓦特表沒有發送任何數據',
    noDataEnergyFlowHelp: '需要幫忙？根據狀態 LED 的顏色，請執行以下操作：',
    noDataEnergyFlowLedGrey: '将监控器上电',
    noDataEnergyFlowLedBlue1: '确认Wi-Fi处于工作状态',
    noDataEnergyFlowLedBlue2: '若Wi-Fi有变,请更新监控设备的Wi-Fi设置',
    noDataEnergyFlowLedGreen: '联系我们:泛在能控客服 WX:smartModulino QQ:786763176',
};
